import { useParams } from 'react-router';

export function useSelectedClientId() {
  const { clientId } = useParams();

  return clientId || null;
}
